import React from 'react';
import { Container, Typography, Grid, Card, CardContent, List, ListItem, ListItemText } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import { getBreadcrumbSchema } from '../components/StructuredData';

const About: React.FC = () => {
  const { t } = useTranslation();

  const values = t('about.values.items', { returnObjects: true }) as string[];

  return (
    <Container sx={{ py: 8 }}>
      <SEO
        title={t('seo.about.title')}
        description={t('seo.about.description')}
        canonicalPath="/about"
        jsonLd={[
          getBreadcrumbSchema([
            { name: 'Home', url: '/' },
            { name: t('about.title'), url: '/about' },
          ]),
        ]}
      />

      <Typography variant="h3" component="h1" gutterBottom align="center">
        {t('about.title')}
      </Typography>

      <Grid container spacing={4} sx={{ mt: 2 }}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h5" component="h2" gutterBottom>
                {t('about.mission.title')}
              </Typography>
              <Typography variant="body1">
                {t('about.mission.description')}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h5" component="h2" gutterBottom>
                {t('about.team.title')}
              </Typography>
              <Typography variant="body1">
                {t('about.team.description')}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h5" component="h2" gutterBottom>
                {t('about.values.title')}
              </Typography>
              <List>
                {values.map((value, index) => (
                  <ListItem key={index}>
                    <ListItemText primary={value} />
                  </ListItem>
                ))}
              </List>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default About;
